import type {ForestMassSpeciesCreate} from '@/domain/entities/ForestMassSpecies';
import type {ForestMassSpeciesRepository} from '@/domain/interfaces/ForestMassSpeciesRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {ForestMassSpeciesDto} from './ForestMassSpeciesDto';
import {toDomain} from './ForestMassSpeciesMappers';

const PATH = 'forest-mass-species/';

export class RestForestMassSpeciesRepository implements ForestMassSpeciesRepository {
  constructor(private readonly httpClient: HttpClient) {}
  get = async (uuid: string) => {
    const dto = await this.httpClient.get<ForestMassSpeciesDto>(`${PATH}${uuid}`);
    return dto ? toDomain(dto) : undefined;
  };
  create = async (entity: ForestMassSpeciesCreate) => {
    const forestMassSpecies = await this.httpClient.post<ForestMassSpeciesCreate, ForestMassSpeciesDto>(
      `${PATH}`,
      entity,
    );
    return toDomain(forestMassSpecies);
  };

  delete = async (uuid: string) => {
    await this.httpClient.delete(`${PATH}${uuid}`);
  };

  getByForestMassUuid = async (uuid: string) => {
    const forestMassSpecies = await this.httpClient.get<Array<ForestMassSpeciesDto>>(`${PATH}?forestMassUuid=${uuid}`);
    return forestMassSpecies.map((forestMassSpecies) => toDomain(forestMassSpecies));
  };

  getBySpeciesUuid = async (uuid: string) => {
    const forestMassSpecies = await this.httpClient.get<Array<ForestMassSpeciesDto>>(`${PATH}?speciesUuid=${uuid}`);
    return forestMassSpecies.map((forestMassSpecies) => toDomain(forestMassSpecies));
  };
}
